// extracted by mini-css-extract-plugin
export var container = "_w8-0";
export var table = "_w8-2";
export var tableWrapper = "_w8-1";